<div class="flex items-center gap-x-1 flex-row justify-start">
  <img
    class="block h-6 w-6"
    *ngIf="battery?.status === BatteryStatus.Full"
    src="assets/iconography/battery-full.svg"
    alt="battery full" />

  <img
    class="block h-6 w-6"
    *ngIf="battery?.status === BatteryStatus.Good"
    src="assets/iconography/battery-good.svg"
    alt="battery good" />

  <img
    class="block h-6 w-6"
    *ngIf="battery?.status === BatteryStatus.Low"
    src="assets/iconography/battery-low.svg"
    alt="battery low" />

  <img
    class="block h-6 w-6"
    *ngIf="battery?.status === BatteryStatus.Critical"
    src="assets/iconography/battery-critical.svg"
    alt="battery critical" />

  <img
    *ngIf="!battery || battery.status === BatteryStatus.Unknown"
    class="block h-6 w-6"
    src="assets/iconography/battery-offline.svg"
    alt="Unknown" />
  <span class="text__small night min-w-9">{{ battery?.percentage ? battery.percentage + '%' : '' }}</span>
</div>
